<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('faceDisponible.title', { week: this.$route.params.yearWeek.substr(4) }) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{ $t('general.button.return')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px column is-12 overflow-x-hidden" v-if="this.week">
      <tab-tournee-face-semaine :ref="referenceTable"
                                :referenceTable="referenceTable"
                                :filtres="filtres"
                                :actions="actions"
                                ligneCommandeId=""
                                :afficherDate="true"
                                :mustDisplayOnlyDispoTfs="true"
                                :afficherBoutonAffecter="false"
                                :afficherBoutonDesaffecter="false"
                                :anneeSemaine="this.week"
                                :typeDonnee="constantes.EXPORT_EXCEL_FACE_DISPONIBLE">
      </tab-tournee-face-semaine>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import {
  ACTION_AFFICHAGE, ACTION_INSTRUCTION_POSE, ACTION_LAISSER_EN_PLACE,
  ACTION_ENLEVER_LAISSER_EN_PLACE, EXPORT_EXCEL_FACE_DISPONIBLE,
  ACTION_AFFECTER_LISTE_AFFICHAGE,
} from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import { REFERENCE_TABLE_DEMANDE_FACES_DISPONIBLES } from '@/configuration/general/referenceTableConf';

const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');

export default {
  name: 'l_faceDisponible',
  data() {
    return {
      filtres: {
        estAffecte: true,
      },
      actions: [
        { action: ACTION_AFFICHAGE, translation: 'faceDisponible.actions.actionAffichage' },
        { action: ACTION_INSTRUCTION_POSE, translation: 'faceDisponible.actions.instructionPose' },
        { action: ACTION_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.laisserEnPlace' },
        { action: ACTION_ENLEVER_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.enleverLaisserEnPlace' },
        { action: ACTION_AFFECTER_LISTE_AFFICHAGE, translation: 'faceDisponible.actions.affecterListeAffichage' },
      ],
      week: null,
      constantes: {
        EXPORT_EXCEL_FACE_DISPONIBLE,
      },
      referenceTable: REFERENCE_TABLE_DEMANDE_FACES_DISPONIBLES,
    };
  },
  components: {
    breadcrumb,
    tabTourneeFaceSemaine,
  },
  computed: {
    ...TourneeFaceSemaine.mapGetters({
      critereRecherche: 'critereRecherche',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('faceDisponible.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('faceDisponible.breadcrumb.listeDemande'), route: { name: 'l.logistique.demande-auto' }, isActive: false },
        { title: this.$i18n.t('faceDisponible.breadcrumb.restriction'), route: '', isActive: true },
      ];
    },
  },
  mounted() {
    this.week = Number(this.$route.params.yearWeek);
    this.critereRecherche.avecLaisserEnPlaceVente = null;
    this.critereRecherche.afficheurIds = [];
    this.critereRecherche.sansAfficheur = null;
    this.setInformationPage(this.$t('pageLogistique.demande.facesDispo'));
  },
};
</script>

<style scoped>

</style>
